<template>
    <div
        class="accordion__item"
        :class="{ 'acordion-item--unavailable': isDisabled }"
        :id="`item-${uuid}`"
    >
        <div
            class="accordion__item-header"
            @click="onClick"
        >
            <slot name="title"></slot> <!-- div with property class="accordion__title" is expected-->
            <div class="accordion__item-header-control">
                <i :class="iconClass" />
            </div>
        </div>
        <div
            v-if="isOpen"
            ref="contentBox"
            class="accordion__item-content"
        >
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';


    /**
     * Be aware that this component talks to parent in hacky way (not by props-event as recommended)
     * but the component calls $parent's methods directly. Vue does not recommend this pattern
     * but we use is it here as an exception to simplify usage od accordion.
     */
    export default Vue.component('AccordionItem', {
        name: 'AccordionItem',
        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isOpen: this.$parent.active === this.uuid,
            };
        },
        watch: {
            '$parent.active': function (newActive) {
                this.isOpen = newActive && newActive.index === this.uuid;
            }
        },
        updated() {
            if (this.isOpen) {
                this.$parent.setActiveHeight(this.$refs.contentBox.clientHeight);
            }
        },
        computed: {
            iconClass() {
                const iconClassNames = ['icon', 'icon--lg', 'toggle-icon'];
                if (this.isOpen) {
                    iconClassNames.push(' icon-chevron_up');
                } else {
                    iconClassNames.push(' icon-chevron_down');
                }
                return iconClassNames;
            },
        },
        methods: {
            onClick() {
                if (this.isDisabled) {
                    return;
                }
                this.$parent.setActive({
                    index: this.uuid,
                    height: 0,
                });
            },
        },
        beforeCreate() {
            this.uuid = this.$parent.getUuid();
        }
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/accordion/AccordionItem.vue